import { axiosInstance } from '../axios';
import type { ApiResponse } from '../../types/common';
import type {
  RoleResponse,
  PermissionResponse,
  RoleRequest,
  PermissionRequest,
  PermissionRegistry,
} from '../../types/role';

export const rolesApi = {
  getAll: () =>
    axiosInstance.get<ApiResponse<RoleResponse[]>>('/v1/roles'),

  getById: (id: string) =>
    axiosInstance.get<ApiResponse<RoleResponse>>(`/v1/roles/${id}`),

  create: (data: RoleRequest) =>
    axiosInstance.post<ApiResponse<string>>('/v1/roles', data),

  update: (id: string, data: RoleRequest) =>
    axiosInstance.put<ApiResponse<string>>(`/v1/roles/${id}`, data),

  delete: (id: string) =>
    axiosInstance.delete<ApiResponse<string>>(`/v1/roles/${id}`),

  getPermissions: (id: string) =>
    axiosInstance.get<ApiResponse<PermissionResponse>>(`/v1/roles/${id}/permissions`),

  getRegistry: () =>
    axiosInstance.get<ApiResponse<PermissionRegistry>>('/v1/roles/registry'),

  updatePermissions: (id: string, data: PermissionRequest) =>
    axiosInstance.put<ApiResponse<string>>(`/v1/roles/${id}/permissions`, data),
};
